module.exports = __webpack_public_path__ + "static/media/bg.e1c2cd9f.png";